
let base = window._env_.VUE_APP_ADMIN_HOST

/**
 * 创建省份分组
 * @param {Object} data - 分组数据
 * @param {string} data.split_name - 分组名称
 * @param {number} data.provinceid - 省份ID
 * @param {string[]} data.cityids - 城市ID数组
 * @returns {Promise} - 返回Promise对象
 */
export function createCityGroup (data) {
  // 转换参数格式以匹配后端接口
  const params = {
    provinceid: data.provinceId,
    split_name: data.split_name,
    cityids: data.cityIds.map(id => id.toString()) // 确保城市ID是字符串类型
  }


  return axios.post(`${base}/data_screen/province_split/create`, params)
}

/**
 * 更新省份分组
 * @param {number} id - 分组ID
 * @param {Object} data - 更新的分组数据
 * @param {string} data.name - 分组名称
 * @param {number} data.provinceId - 省份ID
 * @param {number[]} data.cityIds - 城市ID数组
 * @returns {Promise} - 返回Promise对象
 */
export function updateCityGroup (id, data) {
  // 转换参数格式以匹配后端接口
  const params = {
    provinceid: data.provinceId,
    split_name: data.split_name,
    cityids: data.cityIds.map(id => id.toString()) // 确保城市ID是字符串类型
  }

  return axios.post(`${base}/data_screen/province_split/update_${id}`, params)
}

/**
 * 获取省份分组详情
 * @param {number} id - 分组ID
 * @returns {Promise} - 返回Promise对象
 */
export function getCityGroupDetail (id) {
  return axios.get(`${base}/data_screen/province_split/get_${id}`)
}

export function getList (params) {
  return axios.post(`${base}/data_screen/province_split/query`, params)
}



// WEBPACK FOOTER //
// ./src/views/statistic/pages/CityGroup/city-group.api.js